module.exports = __webpack_public_path__ + "c1aa179c8aec4220215db76a34cdf795.svg";